<template>
  <v-list two-line avatar>
    <v-subheader>Become someone else</v-subheader>
    <template v-for='user in becomeUsers'  >
      <v-list-tile :key='`user=${user.id}`' >
        <v-list-tile-avatar>
          <img v-if='user.profile' :src="user.profile" />
          <v-icon v-else >person</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>{{user.full_name}}</v-list-tile-content>
        <v-list-tile-action>
          <v-btn @click='login(user.id)' flat>Become</v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider :key='user.id' ></v-divider>
    </template>
  </v-list>
</template>

<script>
import {LOGIN} from '@/store/constants'
export default {
  name: 'Become',
  data () {
    return {}
  },
  mounted () {
    this.$appointmentguru.resource('auth.become').id('become').list()
  },
  computed: {
    becomeUsers () {
      let req = this.$store.getters.getRequestById('become', true)
      return this.getObjectPath(req, 'result.data', [])
    },
    becomeRequest () {
      return this.$store.getters.getRequestById('do-become', true)
    },
    becomeRequestStatus () {
      return this.becomeRequest.status
    }
  },
  watch: {
    becomeRequestStatus () {
      if (this.becomeRequestStatus === 200) {
        console.log(JSON.stringify(this.becomeRequest.result.data))
        this.$store.dispatch(LOGIN, this.becomeRequest.result.data)
        window.alert('You are logged in as them now')
      }
    }
  },
  methods: {
    login (userId) {
      let data = {become_id: userId}
      console.log(data)
      this.$appointmentguru.resource('auth.become').id('do-become').create(data)
      // vm.$store.dispatch(LOGIN, data)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Become.vue?267ca7ea